
  import { VERSION_STRING } from './config/version.js';

  if ('serviceWorker' in navigator) {
    window.addEventListener('load', async () => {
      const serviceWorkerUrl = new URL('./service-worker.js', window.location.href);
      serviceWorkerUrl.searchParams.set('v', VERSION_STRING);

      // Unregister any stale service workers (e.g., old sw.js registered at root scope)
      try {
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (const reg of registrations) {
          const scriptURL = reg.active?.scriptURL || reg.installing?.scriptURL || reg.waiting?.scriptURL || '';
          const scriptPathname = scriptURL ? new URL(scriptURL).pathname : '';
          if (scriptURL && !scriptPathname.endsWith('/service-worker.js')) {
            await reg.unregister();
          }
        }
      } catch (_) { /* ignore cleanup errors */ }

      // Silently check if service-worker.js exists without logging errors
      fetch(serviceWorkerUrl, { method: 'HEAD', cache: 'no-store' })
        .then(response => {
          if (response.ok) {
            return navigator.serviceWorker.register(serviceWorkerUrl, {
              updateViaCache: 'none',
            });
          }
          // File doesn't exist - silently skip (development mode)
          return null;
        })
        .then(registration => {
          if (!registration) return;
          
          // Check for updates
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (!newWorker) return;
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New version available - show toast instead of blocking confirm dialog
                if (window.toast) {
                  window.toast.info('Nova versão disponível!', 0, () => {
                    newWorker.postMessage({ type: 'SKIP_WAITING' });
                    window.location.reload();
                  });
                } else if (confirm('Nova versão disponível! Recarregar a página?')) {
                  newWorker.postMessage({ type: 'SKIP_WAITING' });
                  window.location.reload();
                }
              }
            });
          });
        })
        .catch(() => {
          // Silently ignore - development mode without service worker
        });
    });
  }
